import { makeStyles } from '@material-ui/core/styles';
import theme from '../../theme/booking-theme';

const footerPaymentWithModalStyles = makeStyles({
  CheckboxErrorMessage: {
    display: 'block',
  },
  hideElement: { display: 'none' },
  error: {
    borderTop: `3px solid ${theme.palette.error.main}`,
    background: `${theme.palette.white}`,
    boxShadow: '0px -2px 4px 0px rgba(6, 21, 86, 0.15)',
  },
  errorMessage: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    '& p': {
      marginLeft: '8px',
      color: `${theme.palette.error.main}`,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: '600',
      lineHeight: '120%',
    },
  },
  checkboxLabel: {
    paddingLeft: '8px',
    '& p:first-child': {
      border: '0',
      margin: '0',
      fontWeight: '600',
      '& span': {
        color: theme.palette.blue2,
        cursor: 'pointer',
      },
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: '4px',
      paddingLeft: '8px',
      display: 'flex',
      flexDirection: 'column',
      '& button': {
        marginLeft: '0px!important',
      },
    },
  },
  modalContainer: {
    padding: '36px 20px',
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      padding: '36px 48px',
      fontSize: theme.typography.pxToRem(16),
    },
    '& .content': {
      paddingRight: '24px',
    },
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    '& .title': {
      fontSize: theme.typography.pxToRem(22),
      lineHeight: '120%',
      color: theme.palette.blue1,
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
    '& button': {
      padding: '0',
      height: '40px',
      width: '40px',
      display: 'contents',
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
      },
    },
  },
  footerModal: {
    marginTop: '22px',
    '& .fontBold': {
      fontWeight: '600',
    },
  },
  footerContainer: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    justifyContent: 'center',
    boxShadow: `0 -2px 4px 0 ${theme.palette.shadow}`,
  },
});
export default footerPaymentWithModalStyles;
